import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SummaryApi from '../common/index';

function LoginModal() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(SummaryApi.signIn.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok && data.user) {
        // ✅ Save user data
        localStorage.setItem('admin', JSON.stringify(data.user));
        alert('Login successful!');
        navigate('/'); // ✅ Go to homepage
      } else {
        alert(data.message || 'User not found');
      }
    } catch (err) {
      alert('Something went wrong');
      console.error(err);
    }
  };

  const handleCancel = () => {
    navigate('/'); // Close and go back to home
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md relative">
        <button
          onClick={handleCancel}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
        >
          &times;
        </button>

        <h2 className="text-2xl font-bold mb-4 text-center">Login</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            required
            className="w-full p-2 border"
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            required
            className="w-full p-2 border"
          />
          <div className="flex justify-between mt-4">
            <button type="submit" className="bg-orange-500 text-white px-4 py-2 rounded">
              Login
            </button>
            <button type="button" onClick={handleCancel} className="text-gray-600 hover:text-gray-800">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginModal;
